import script from "./sidebarIcons.vue?vue&type=script&setup=true&lang=ts"
export * from "./sidebarIcons.vue?vue&type=script&setup=true&lang=ts"

import "./sidebarIcons.vue?vue&type=style&index=0&id=f7c035da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7c035da"]])

export default __exports__